import { Outlet } from "react-router";

const Shifts = () => {
  return <Outlet />;
};

export default Shifts;
